import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon } from 'react-icons/fa';

import {
  sharedActions,
} from './store/actions';

class LegalEntitySettingsAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      legalEntity: PropTypes.string,
    }).isRequired,
    showLegalEntitySettingsModalForAddEdit: PropTypes.func.isRequired,
  };

  showLegalEntitySettingsModalForEdit = () => {
    const { value, showLegalEntitySettingsModalForAddEdit } = this.props;
    showLegalEntitySettingsModalForAddEdit(value);
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Legal Entity Settings"
          onClick={this.showLegalEntitySettingsModalForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showLegalEntitySettingsModalForAddEdit: sharedActions.showModalForAddEdit,
  }
)(LegalEntitySettingsAdminColumnRenderer);
